import { render, staticRenderFns } from "./UiTextInputDialog.vue?vue&type=template&id=5dbc7f3e"
import script from "./UiTextInputDialog.vue?vue&type=script&lang=js"
export * from "./UiTextInputDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports